const authKeysToClear = [
  "token",
  "userId",
  "loginId",
  "loginTime",
  "department",
  "userRole",
  "userType",
  "typeOfAgreement",
  "phoneNumber",
  "phoneNumberIv",
  "otp",
  "otpIv",
  "vendorName",
  "vendorPhone",
  "state",
  "address",
  "city",
  "fromLogin",
  "justLoggedIn",
];

export const clearAuthSession = () => {
  authKeysToClear.forEach((key) => localStorage.removeItem(key));
  sessionStorage.clear();
};